import { alpha, border, maxWidth, minWidth } from "@mui/system";

const useStyles = (theme, open) => ({
  boxContainer: {
    minHeight: "0px",
    width: "100%",
    minWidth: "240px",
  },
  boxInputSelect: {
    width: "100%",
    position: "relative",
    minHeight: "40px",
    borderRadius: "5px",
    paddingX: 1,
    paddingY: open ? 1 : 0,
    gap: 1,
    cursor: "pointer",
    display: "flex",
    alignItems: open ? "start" : "center",
    justifyContent: "space-between",
    flexWrap: "nowrap",
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${alpha(theme.palette.text.main, 0.3)}`,
    zIndex: 1,
    "&:hover": {
      border: `1px solid ${theme.palette.text.main}`,
    },
    "&.focused": {},
  },
  input: {
    color: theme.palette.background.paper,
    cursor: "pointer",
    height: "0px",
    backgroundColor: "transparent",
    boxSizing: "border-box",
    padding: "4px 6px",
    width: "0px",
    display: "none",
    flexGrow: 1,
    border: 0,
    margin: 0,
    outline: 0,
  },
  boxTags: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 0.5,
    maxHeight: open ? "120px" : "40px",
    justifyContent: "start",
    alignItems: "start",
    paddingY: open ? 0 : 1,
    minWidth: "50px",
  },
  label: {
    fontWeight: "bold",
    color: "text.secondary",
    fontSize: "12px",
    height: "100%",
  },
  divTag: (onDelete) => ({
    display: "flex",
    alignItems: "center",
    height: "fit-content",
    maxWidth: "20px",
    borderRadius: "6px",
    backgroundColor: theme.palette.chip.background.info,
    boxSizing: "content-box",
    padding: onDelete ? "1px 4px 1px 10px" : "0 10px 0 10px",
    outline: 0,
    fontSize: "14px",
    fontWeight: "bold",
    textTransform: "capitalize",
    maxWidth: "100px",
    width: "fit-content",
    zIndex: 3,
  }),
  textTag: {
    fontSize: "11px",
    fontWeight: "bold",
    textTransform: "capitalize",
    overflow: "hidden",
    whiteSpace: "nowrap",
    width: "fit-content",
    maxWidth: "100px",
    textOverflow: "ellipsis",
  },
  closeIcon: {
    color: "text.secondary",
    fontWeight: "bold",
    fontSize: "16px",
    cursor: "pointer",
    zIndex: 3,
  },
  menu: (listBoxWidth) => ({
    "& .MuiList-root ": {
      width: listBoxWidth,
      minWidth: "100px",

      p: 0,
    },
    "& .MuiPaper-root.MuiPopover-paper.MuiMenu-paper ": {
      marginTop: "5px",
      borderRadius: 1,
      boxShadow: "0px 4px 14px 0px  #0000002c",
    },
  }),
  menuItem: (isSelected, disabled) => ({
    cursor: "pointer",
    padding: "6px 12px",
    display: "flex",
    borderRadius: 1,
    gap: 1.5,
    margin: "4px",
    /*   color: disabled
      ? theme.palette.text.disabled
      : isSelected
      ? theme.palette.text.primary
      : theme.palette.text.secondary, */
    /*   backgroundColor: isSelected
      ? alpha(theme.palette.background.textField, 0.3)
      : "transparent",
    "&:hover": {
      backgroundColor: disabled
        ? "transparent"
        : isSelected
        ? alpha(theme.palette.primary.main, 0.1)
        : alpha(theme.palette.background.textField, 0.5),
    }, */
  }),
  menuItemSelectAll: (disabled) => ({
    justifyContent: "left",
    width: "calc(100% - 0.5rem)",
    padding: "6px 12px",
    display: "flex",
    fontSize: "1rem",
    borderRadius: 1,
    gap: 1,
    margin: "4px",
    /*    color: disabled ? theme.palette.text.disabled : theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper, */
    "&:focused": {
      backgroundColor: "transparent",
    },
    /*     "&:hover": {
      backgroundColor: disabled
        ? "transparent"
        : alpha(theme.palette.primary.main, 0.1),
      color: disabled
        ? theme.palette.text.disabled
        : theme.palette.primary.main,
    }, */
  }),
});

export default useStyles;
